import { motion } from "framer-motion";

/**
 * PaintKing crown + brush emblem.
 * Monoline SVG designed to sit inside sharp 1px border boxes.
 */
export default function Emblem({ size = 44, className = "", spin = false }) {
    return (
        <motion.svg
            viewBox="0 0 120 120"
            width={size}
            height={size}
            className={className}
            initial={{ opacity: 0, y: -10 }}
            animate={{
                opacity: 1,
                y: 0,
                rotate: spin ? [0, 4, -4, 0] : 0,
            }}
            transition={{
                duration: 1,
                ease: [0.19, 1, 0.22, 1],
                delay: 0.15,
                rotate: {
                    duration: 6,
                    repeat: spin ? Infinity : 0,
                    ease: "easeInOut",
                },
            }}
            aria-label="PaintKing crown and brush emblem"
        >
            <defs>
                <linearGradient id="pk-rain" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#FF2BD6" />
                    <stop offset="25%" stopColor="#FF4500" />
                    <stop offset="50%" stopColor="#FFE600" />
                    <stop offset="75%" stopColor="#00FF85" />
                    <stop offset="100%" stopColor="#00E5FF" />
                </linearGradient>
            </defs>
            {/* Crown */}
            <path
                d="M18 46 L34 68 L46 30 L60 70 L74 30 L86 68 L102 46 L96 84 L24 84 Z"
                fill="none"
                stroke="url(#pk-rain)"
                strokeWidth="3"
                strokeLinejoin="miter"
                strokeLinecap="square"
            />
            {/* Crown gems */}
            <circle cx="18" cy="46" r="3" fill="#FFE600" />
            <circle cx="60" cy="30" r="3.2" fill="#FF2BD6" />
            <circle cx="102" cy="46" r="3" fill="#00E5FF" />
            {/* Brush handle */}
            <rect
                x="52"
                y="88"
                width="16"
                height="8"
                fill="#FFFFFF"
            />
            {/* Ferrule */}
            <rect
                x="48"
                y="96"
                width="24"
                height="6"
                fill="#0A0A0A"
                stroke="#FFFFFF"
                strokeWidth="1.5"
            />
            {/* Bristle drip */}
            <path
                d="M48 102 L48 112 L54 118 L60 108 L66 118 L72 102"
                fill="url(#pk-rain)"
            />
        </motion.svg>
    );
}
